import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import ThumbsUpIcon from '@nv/images/design/thumbs-up-icon'
import { useTranslation } from 'react-i18next'
import styles from './ConfirmNomination.module.scss'

export const ConfirmNomination = ({ confirm }) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(t('main.supportCandidate'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onClose, variant: 'secondary' },
      { text: t('buttons.ok'), onClick: confirm },
    ])
  }, [])

  return (
    <div className={styles['container']}>
      <ThumbsUpIcon />
      <span>{t('main.youAreNominating')}</span>
    </div>
  )
}
